/* eslint-disable @typescript-eslint/naming-convention */
const sharedRoutes = {
  stopImpersonating: "/a/sessions/stop_impersonating",

  external: {
    support: "https://support.fullscript.com/",
    termsOfService: "https://fullscript.com/terms-of-service",
    privacyPolicy: "https://fullscript.com/privacy",
    accessibility: "https://fullscript.com/accessibility",
    californiaPrivacy: "https://fullscript.com/ccpa",
    autoshipHandout: "https://fs-marketing-files.s3.amazonaws.com/handouts/autoship-education.pdf",
    shippingPolicyWholesale:
      "https://support.fullscript.com/hc/en-us/articles/360047665712-Wholesale-shipping-policy",
    shippingPolicyRetail:
      "https://support.fullscript.com/hc/en-us/articles/360020978272-Patient-shipping-policy",
    refundPolicy: "https://support.fullscript.com/hc/en-us/articles/360020956252-Refunds-returns",
    protocolsMarketingPage:
      "https://support.fullscript.com/hc/en-us/articles/360046986612-Sharing-wellness-protocols-with-patients",
    profitDispensariesSupportPage:
      "https://support.fullscript.com/hc/en-us/articles/360022163832-Profit-dispensaries",
    wellevateMigrationSupport:
      "https://support.fullscript.com/hc/en-us/sections/13558530393115-Wellevate-migration",
  },
} as const;

export { sharedRoutes };
